export function isSpecialTagSelected(selectedTags) {
  const searchValues = ["not interested", "completed"];
  const hasAny = searchValues.some((value) => selectedTags.includes(value));
  return hasAny;
}
